module.exports = __webpack_public_path__ + "img/partner9.91335443.png";